import { SearchObject } from "app/common/Model/SearchObject";
import { exportAccountsDebt } from "app/services/InvoiceItemService";
import { reportDebt } from "app/services/ReportService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
export default class ReportDebtStore {
  listDataDebt = null;
  searchReportDebt = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    departmentId: null,
    staffId: null
  }
  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchDebt = (searchReportDebt) => {
    this.searchReportDebt = {
      ...this.searchReportDebt,
      ...searchReportDebt,
    };
    this.pagingReportDebt();
  }

  pagingReportDebt = async () => {
    let { departmentId, staffId, ...ortherData } = this.searchReportDebt;
    if (staffId) {
      ortherData.staffId = staffId?.id;
    }
    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }
    return await reportDebt({ ...ortherData })
      .then(({ data }) => {
        this.listDataDebt = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thẻ trả trước có lỗi");
      });
  };

  handleExportAccountsDebt = async (searchObj) => {
    const search = this.normalizeSearchReportVoucher(searchObj);
    try {
      const response = await exportAccountsDebt(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BC_CONG_NO.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchReportVoucher = (rawSearch = {}) => {
    const { staffId, departmentId, ...rest } = rawSearch;
    return {
      ...rest,
      staffId: staffId?.id || null,
      departmentId: departmentId?.id || null,
    };
  };

  resetStore = () => {
    this.listData = null
    this.searchFee = { ...new SearchObject(), fromDate: new Date(), toDate: new Date() }

  }
}